import { UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler, UIComponentProps } from '../../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../../utils/basecontext';
import { UIComponentView } from '../../../../../toolkit/uicomponentview';
import { ToneDto } from '../../../../../../core/dto/tonedto';
import { UIComponentCSSStyle } from '../../../../../toolkit/uicomponentcss';
import {  ToneCardCSSStyle } from './tonecardcssstyle';
import { ToneCardViewImpl } from './tonecardview';
import { APIModelHandler, APIModel } from '../../../../../toolkit/uicomponentapimodel';
import { ToneCardAPIModelImpl, ToneCardAPIModel } from './tonecardapimodel';
import { AudioPlayerWithProgress } from 'src/com/sixdee/crbtportal/ui/toolkit/player/playerwithprogress/playerwithprogressimpl';
import { APIFeatures } from 'src/com/sixdee/crbtportal/core/util/apifeatures';
import { AlertType } from 'src/com/sixdee/crbtportal/ui/toolkit/alert/alerttype';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { ToneRowOptionsPrivilage } from 'src/com/sixdee/crbtportal/ui/toolkit/toneoptions/tone/tonerowcomponent';
import { PlayerComponentCSSStyle } from 'src/com/sixdee/crbtportal/ui/toolkit/player/playercss';


export interface ToneCardComponentProps extends UIComponentProps
{

    toneDto: ToneDto;
    position: number;
    cardStyle :ToneCardCSSStyle;

    audioPlayerWithProgress: AudioPlayerWithProgress;
    marginTop: string;
    toneRowOptionsPrivilage: ToneRowOptionsPrivilage;
    playerCSSStyle: PlayerComponentCSSStyle;
    mobilePlayerCSSStyle:PlayerComponentCSSStyle;
    isPlayInitial?: boolean;
    onDeleteClicked(toneDto: ToneDto): void;
    onSelected(toneDto: ToneDto, position: number): void;
}

export interface ToneCardComponentState extends UIComponentState
{
   isHovered: boolean;
   isActionHovered: boolean;
   toneRowOptionsPrivilage: ToneRowOptionsPrivilage;
}

export interface ToneCardComponentHandler extends UIComponentHandler
{
    addToWishlist(): void;
    onSelected(): void;
    onSettingsClicked(): void;
    onHovered():void;
    onDeleteClicked(): void;
    onHoveredExit():void;
    onActionHovered():void;
    onActionHoveredExit():void;
}

export class ToneCardComponent extends UIComponentImpl<ToneCardComponentProps, ToneCardComponentState, UIDataModel> implements ToneCardComponentHandler
{
    constructor(props: ToneCardComponentProps)
    {
        super(props);

        this.state = {isHovered: false, isActionHovered: false, toneRowOptionsPrivilage: props.toneRowOptionsPrivilage};
    }

    componentDidMount()
    {
        (this.getView() as ToneCardViewImpl).setPlayerWithProgress(this.props.audioPlayerWithProgress);
        // if(this.props.isPlayInitial !== undefined && this.props.isPlayInitial)
        // {
        // }
    }

    playStart()
    {
        (this.getView() as ToneCardViewImpl).onPlayStart();
    }

    UNSAFE_componentWillReceiveProps(nextProps: ToneCardComponentProps)
    {
        (this.getView() as ToneCardViewImpl).setPlayerWithProgress(nextProps.audioPlayerWithProgress);
        // if(this.props.isPlayInitial !== undefined && this.props.isPlayInitial)
        // {
        //     (this.getView() as ToneCardViewImpl).onPlayStart();
        // }
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ToneCardViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
    
        return this.props.cardStyle;
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ToneCardAPIModelImpl(applicationContext, apiModelHandler);
    }

    componentWillReceiveProps(nextProps: ToneCardComponentProps)
    {
        this.setState({toneRowOptionsPrivilage: nextProps.toneRowOptionsPrivilage});
    }

    onSelected(): void 
    {
       this.props.onSelected(this.props.toneDto, this.props.position);
    }

    onHovered(): void {
        this.setState({isHovered: true, isActionHovered: false});
    }

    onHoveredExit(): void {
        this.setState({isHovered: false, isActionHovered: false});
    }

    onActionHovered(): void 
    {
        this.setState({isHovered: false}, ()=>
        {
            this.setState({isActionHovered: true});
        });
    }

    onActionHoveredExit(): void {
        this.setState({isActionHovered: false, isHovered: true});
    }
    onSettingsClicked(): void {
       console.log("onSettings clicked");

    //    this.props.context.setToneContext(this.props.toneDto);

    //    this.props.context.getRedirectionHandler().routeNextFeature(RoutingFeatures.ADVANCE_SETTINGS 
    //     + "?tone-id=" +this.props.toneDto.getId(), true);
        this.props.onSelected(this.props.toneDto, this.props.position);
    }
    addToWishlist(): void {
        (this.getView() as ToneCardViewImpl).showLoader(); 
        (this.getAPIModel() as ToneCardAPIModel).addToWishlist(this.props.toneDto);
    }

    onDeleteClicked(): void 
    {
        (this.getView() as ToneCardViewImpl).showLoader(); 
        (this.getAPIModel() as ToneCardAPIModel).deleteTone(this.props.toneDto);
    }

    componentWillUnmount()
    {
        this.props.audioPlayerWithProgress.unRegisterEvents();
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as ToneCardViewImpl).dismissLoader(); 
        if(feature === APIFeatures.ADD_TO_WISHLIST)
        {
            (this.getView() as ToneCardViewImpl).showPopup(this.getContext().getResources().getString(Strings.wishlist),this.getContext().getResources().getString(Strings.wishlist_add_order_is_successfully_completed),AlertType.SUCCESS);
        }
        else if(feature === APIFeatures.DELETE_FROM_WISHLIST)
        {
            (this.getView() as ToneCardViewImpl).showPopup(this.getContext().getResources().getString(Strings.delete),this.getContext().getResources().getString(Strings.wishlist_delete_order_is_successfully_completed),AlertType.SUCCESS);
        }
        else
        {
            (this.getView() as ToneCardViewImpl).showPopup(this.getContext().getResources().getString(Strings.delete),this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),AlertType.SUCCESS);
        }
    }
    
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as ToneCardViewImpl).dismissLoader(); 
        if(feature === APIFeatures.ADD_TO_WISHLIST)
        {
            (this.getView() as ToneCardViewImpl).showPopup(this.getContext().getResources().getString(Strings.wishlist),description,AlertType.ERROR);

        }
        else
        {
            (this.getView() as ToneCardViewImpl).showPopup(this.getContext().getResources().getString(Strings.delete),description,AlertType.ERROR);
        }
    }  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/tonecard/tonecardcomponent.tsx